import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Loading from 'components/Loading';

export default function InvitationFormComponent(props) {
  const {
    contactName,
    disabled,
    isSending,
    isWorking,
    onChange,
    onGoBack,
    onSubmit,
    preview,
    value,
  } = props;

  return (
    <form onSubmit={onSubmit}>
      <h3 className="heading heading--3 u-space-above act__invitation-form-header">
        {`${contactName} will see this message:`}
      </h3>
      <p className="act__preset-invitation-text" dangerouslySetInnerHTML={{ __html: preview }} />
      <textarea
        className="form__control"
        rows={3}
        name="messageInput"
        placeholder="Add a personal message with the invitation"
        maxLength={1400}
        value={value}
        onChange={onChange}
      />
      <p className="buttons buttons--no-squash act__send-or-go-back">
        <button
          id="ChooseActButton"
          type="submit"
          className={classnames(
            'button button--primary',
            'button--no-margin',
            disabled && 'button--disabled',
          )}
          disabled={disabled || isSending}
        >
          {isWorking ? <Loading spinner small /> : 'Choose'}
        </button>
        <button type="button" className="button button--primary button--no-margin" onClick={onGoBack}>
          <i className="fa fa-arrow-left" />
          {' '}
          Back
        </button>
      </p>
    </form>
  );
}

InvitationFormComponent.propTypes = {
  contactName: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  isSending: PropTypes.bool.isRequired,
  isWorking: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  onGoBack: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  preview: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};